// @flow
import React, { useState, useEffect } from 'react';

import Card from '../../../components/Cards/Card';

import styles from './ArticlesSave.module.scss';
import getDatabg from '../../../controllers/BGsuits.controller';

type IBG = {
  header: {
    textheader: string;
  };

  Content: {
    blockOne: {
      textboone: string;
      textbotwo: string;
      textbothree: string;
      imageUrl: string;
      textbofive: string;
      textbosix: string;
      textboseven: string;
      textboeight: string;
    };
    blockTwo: {
      blockHeaderbtwo: string;
      textbtwoone: string;
      textbtwotwo: string;
      textbtwothree: string;
      textbtfour: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
    };
    blockThree: {
      localHeaderbthree: string;
      textbtone: string;
      textbttwo: string;
      textbtthree: string;
      textbtfour: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
      textbttwelve: string;
      textbtthirteen: string;
      textbtfourteen: string;
      textbtfifteen: string;
      textbtsixteen: string;
      textbtseventeen: string;
      textbteighteen: string;
      textbtnineteen: string;
      textbttwenty: string;
      textbttwentyone: string;
      textbttwentytwo: string;
      textbttwentythree: string;
      textbttwentyfour: string;
      textbttwentyfive: string;
      textbttwentysix: string;
    };
  };
} | null

const BGsuits = () => {
  const [language, setLanguage] = useState<string>('');

  const [data, setData] = useState<IBG>(null);

  const getLanguage = () => {
    const locale = localStorage.getItem('i18nextLng');
    let languageKey;
    switch (locale) {
      case 'en':
        languageKey = 'Eng';
        break;
      case 'ru':
        languageKey = 'Rus';
        break;
      default:
        languageKey = 'Rus';
    }
    return languageKey;
  };

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  const handleRes = async () => {
    const res = await getDatabg(getLanguage());

    setData(res);
  };

  useEffect(() => {
    handleRes();
  }, []);

  if (!data) return null;

  return (
    language
    && (
      <div id="root" className={styles.site}>
        <div className={styles.container}>
          <div className={`${styles.header} ${styles.bg_header}`}>
            <span className={styles.header_text}>{data.header?.textheader}</span>
          </div>
          <div className={styles.content}>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne.textboone}
                <span className={styles.bad_suit}>bad suited</span>
                .
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textbotwo}
                <span className={styles.single_suit}>single suited</span>
                {data.Content.blockOne?.textbothree}
              </div>
            </div>
            <div className={styles.svg}>
              <img
                className={styles.svg}
                // src={data.Content.blockOne?.imageUrl}
                src="https://omahapro.com/api/img/Frame2.png"
                alt="suits"
              />
            </div>
            <div className={`${styles.text} ${styles.caption}`}>
              {data.Content.blockOne?.textbofive}
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockOne?.textbosix}
                <span className={styles.good_suit}>good suited</span>
                {data.Content.blockOne?.textboseven}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockOne?.textboeight}
                <span className={styles.bad_suit}>bad suited</span>
                .
              </span>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.good_suit}`}>
                {data.Content.blockTwo.blockHeaderbtwo}
              </span>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  {data.Content.blockTwo.textbtwoone}
                  <span className={styles.good_suit}>double suited</span>
                  {data.Content.blockTwo.textbtwotwo}
                </span>
              </div>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbtwothree}
                <span className={styles.good_suit}>good suited</span>
                {data.Content.blockTwo.textbtfour}
                <span className={styles.bad_suit}>bad suited</span>
                .
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={`${styles.text} ${styles.line}`}>
                {data.Content.blockTwo.textbtfive}
                <div className={styles.small_hand}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="Q" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="3" />
                </div>
              </span>
            </div>
            <div className={styles.card_and_text_box}>
              <div className={styles.hand}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="kresti" bg="green" size="big" value="Q" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="kresti" bg="green" size="big" value="3" />
              </div>
              <div className={styles.text}>
                <span className={styles.good_suit}>Good suited</span>
                {data.Content.blockTwo.textbtsix}
              </div>
            </div>
            <div className={styles.card_and_text_box}>
              <div className={styles.hand}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="Q" />
                <Card mast="kresti" bg="green" size="big" value="J" />
                <Card mast="kresti" bg="green" size="big" value="3" />
              </div>
              <div className={styles.text}>
                <span className={styles.bad_suit}>Bad suited</span>
                {data.Content.blockTwo.textbtseven}
              </div>
            </div>
            <div className={styles.card_and_text_box}>
              <div className={styles.hand}>
                <Card mast="chervi" bg="red" size="big" value="Q" />
                <Card mast="kresti" bg="green" size="big" value="J" />
                <Card mast="chervi" bg="red" size="big" value="8" />
                <Card mast="kresti" bg="green" size="big" value="7" />
              </div>
              <div className={styles.text}>
                <span className={styles.good_suit}>Good suited</span>
                .
              </div>
            </div>
            <div className={styles.card_and_text_box}>
              <div className={styles.hand}>
                <Card mast="chervi" bg="red" size="big" value="Q" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="kresti" bg="green" size="big" value="8" />
                <Card mast="kresti" bg="green" size="big" value="7" />
              </div>
              <div className={styles.text}>
                <span className={styles.bad_suit}>Bad suited</span>
                .
              </div>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbteight}
                <span className={styles.good_suit}>double suited</span>
                {data.Content.blockTwo.textbtnine}
                <span className={styles.good_suit}>good suited</span>
                .
                <span className={styles.bad_suit}> Bad suited </span>
                {data.Content.blockTwo.textbtten}
              </span>
            </div>
            <div className={styles.block}>
              <span className={`${styles.text} ${styles.mono_suit}`}>
                {data.Content.blockTwo.textbteleven}
              </span>
              <div className={styles.card_box}>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="K" />
                  <Card mast="chervi" bg="red" size="big" value="A" />
                  <Card mast="kresti" bg="green" size="big" value="4" />
                </div>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="K" />
                  <Card mast="kresti" bg="green" size="big" value="A" />
                  <Card mast="chervi" bg="red" size="big" value="4" />
                </div>
                <div className={styles.hand}>
                  <Card mast="chervi" bg="red" size="big" value="Q" />
                  <Card mast="kresti" bg="green" size="big" value="Q" />
                  <Card mast="chervi" bg="red" size="big" value="J" />
                  <Card mast="kresti" bg="green" size="big" value="J" />
                </div>
              </div>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.single_suit}`}>
                {data.Content.blockThree.localHeaderbthree}
              </span>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbtone}
                  <span className={styles.single_suit}>single suited</span>
                  {data.Content.blockThree.textbttwo}
                </span>
              </div>
              <div className={styles.bg_block}>
                <div className={styles.line}>
                  <span className={styles.text}>
                    {data.Content.blockThree.textbtthree}
                  </span>
                  <div className={styles.small_hand}>
                    <Card mast="no" bg="blank" size="small" value="A" />
                    <Card mast="no" bg="blank" size="small" value="K" />
                    <Card mast="no" bg="blank" size="small" value="Q" />
                    <Card mast="no" bg="blank" size="small" value="2" />
                  </div>
                </div>
              </div>
              <div className={styles.bg_line_block}>
                <span
                  className={`${styles.text} ${styles.mono_suit} ${styles.good_suit}`}
                >
                  Good suited:
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="2" />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="bubi" bg="grey" size="big" value="2" />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="Q" />
                    <Card mast="chervi" bg="red" size="big" value="2" />
                  </div>
                </div>
              </div>
              <div className={styles.bg_line_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbtfive}
                </span>
                <div className={styles.line_block}>
                  <span className={styles.text}>
                    <span className={styles.good_suit}>good suited</span>
                    {data.Content.blockThree.textbtsix}
                  </span>
                  <div className={styles.small_hand}>
                    <Card mast="no" bg="blank" size="small" value="A" />
                    <Card mast="no" bg="blank" size="small" value="K" />
                    <Card mast="no" bg="blank" size="small" value="Q" />
                    <Card mast="no" bg="blank" size="small" value="2" />
                  </div>
                  <span className={styles.text}>
                    <span className={styles.single_suit}>
                      {' single suited'}
                    </span>
                    {' + '}
                    <span className={styles.good_suit}>good suited</span>
                    .
                  </span>
                </div>
              </div>
              <div className={styles.bg_line_block}>
                <span
                  className={`${styles.text} ${styles.mono_suit} ${styles.bad_suit}`}
                >
                  Bad suited:
                </span>
                <div className={styles.card_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="bubi" bg="grey" size="big" value="2" />
                  </div>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="bubi" bg="grey" size="big" value="2" />
                  </div>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="chervi" bg="red" size="big" value="2" />
                  </div>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="K"
                    />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="chervi" bg="red" size="big" value="2" />
                  </div>
                </div>
              </div>
              <div className={styles.bg_line_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbtseven}
                  <span className={styles.good_suit}>good suited</span>
                  {data.Content.blockThree.textbteight}
                </span>
                <div className={styles.line_block}>
                  <div className={styles.small_hand}>
                    <Card mast="no" bg="blank" size="small" value="A" />
                    <Card mast="no" bg="blank" size="small" value="K" />
                    <Card mast="no" bg="blank" size="small" value="Q" />
                    <Card mast="no" bg="blank" size="small" value="2" />
                  </div>
                  <span className={styles.text}>
                    <span className={styles.single_suit}>
                      {' single suited'}
                    </span>
                    {' + '}
                    <span className={styles.bad_suit}>bad suited</span>
                    .
                  </span>
                </div>
              </div>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbtnine}
                  <br />
                  {data.Content.blockThree.textbtten}
                  <span className={styles.good_suit}>good suited</span>
                  {data.Content.blockThree.textbteleven}
                  <span className={styles.bad_suit}>Bad suited</span>
                  {data.Content.blockThree.textbttwelve}
                </span>
              </div>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbtthirteen}
                </span>
              </div>
              <div className={styles.bg_line_block}>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="J"
                    />
                    <Card mast="chervi" bg="red" size="big" value="8" />
                    <Card mast="bubi" bg="grey" size="big" value="7" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.single_suit}>
                      Single suited
                    </span>
                    {' + '}
                    <span className={styles.good_suit}>good suited</span>
                    {data.Content.blockThree.textbtfourteen}
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="T" />
                    <Card mast="bubi" bg="grey" size="big" value="8" />
                    <Card mast="chervi" bg="red" size="big" value="7" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.single_suit}>
                      Single suited
                    </span>
                    {' + '}
                    <span className={styles.bad_suit}>bad suited</span>
                    {data.Content.blockThree.textbtfifteen}
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="K" />
                    <Card mast="bubi" bg="grey" size="big" value="J" />
                    <Card mast="chervi" bg="red" size="big" value="7" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="6"
                    />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.single_suit}>
                      Single suited
                    </span>
                    {' + '}
                    <span className={styles.good_suit}>good suited</span>
                    {data.Content.blockThree.textbtsixteen}
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="A"
                    />
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card mast="bubi" bg="grey" size="big" value="8" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.single_suit}>
                      Single suited
                    </span>
                    {' + '}
                    <span className={styles.bad_suit}>bad suited</span>
                    {data.Content.blockThree.textbtseventeen}
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="T"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="8" />
                    <Card mast="chervi" bg="red" size="big" value="5" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.single_suit}>
                      Single suited
                    </span>
                    {' + '}
                    <span className={styles.good_suit}>good suited</span>
                    {data.Content.blockThree.textbteighteen}
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="J"
                    />
                    <Card mast="chervi" bg="red" size="big" value="T" />
                    <Card mast="chervi" bg="red" size="big" value="9" />
                    <Card mast="chervi" bg="red" size="big" value="7" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.single_suit}>
                      Single suited
                    </span>
                    {' + '}
                    <span className={styles.bad_suit}>bad suited</span>
                    {data.Content.blockThree.textbtnineteen}
                  </div>
                </div>
              </div>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbttwenty}
                  <span className={styles.single_suit}>single suited</span>
                  {data.Content.blockThree.textbttwentyone}
                </span>
              </div>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  {data.Content.blockThree.textbttwentytwo}
                  <span className={styles.good_suit}>good suited</span>
                  {data.Content.blockThree.textbttwentythree}
                  <span className={styles.bad_suit}>bad suited</span>
                  <br />
                  {data.Content.blockThree.textbttwentyfour}
                </span>
              </div>
              <div className={styles.bg_line_block}>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="8" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="8"
                    />
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="7" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.bad_suit}>Bad suited</span>
                    .
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="8" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="8"
                    />
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card mast="bubi" bg="grey" size="big" value="7" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.good_suit}>Good suited</span>
                    .
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="8" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="8"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="A" />
                    <Card mast="chervi" bg="red" size="big" value="7" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.bad_suit}>Bad suited</span>
                    .
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card mast="chervi" bg="red" size="big" value="T" />
                    <Card mast="bubi" bg="grey" size="big" value="9" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.good_suit}>Good suited</span>
                    .
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card mast="bubi" bg="grey" size="big" value="T" />
                    <Card mast="bubi" bg="grey" size="big" value="9" />
                  </div>
                  <div className={styles.text}>
                    <span className={styles.bad_suit}>Bad suited</span>
                    .
                  </div>
                </div>
              </div>
              <div className={styles.bg_block}>
                <span className={styles.text}>
                  <span className={styles.good_suit}>Double suited</span>
                  {data.Content.blockThree.textbttwentyfive}
                  <span className={styles.good_suit}>good suited</span>
                  {'. '}
                  <span className={styles.bad_suit}>Bad suited </span>
                  {data.Content.blockThree.textbttwentysix}
                </span>
              </div>
              <div className={styles.bg_line_block}>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="8" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="8"
                    />
                    <Card mast="chervi" bg="red" size="big" value="A" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="7"
                    />
                  </div>
                </div>
                <div className={styles.card_and_text_box}>
                  <div className={styles.hand}>
                    <Card mast="chervi" bg="red" size="big" value="Q" />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="Q"
                    />
                    <Card
                      mast="kresti"
                      bg="green"
                      size="big"
                      value="T"
                    />
                    <Card mast="chervi" bg="red" size="big" value="9" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default BGsuits;
